import store from "../../store";
import * as $http from "@/api/common";
import VueCookie from "vue-cookie";
import router from "@/router";
// 临时登录
export const getTempLogin = function (ok) {
  $http
    .reqTempLogin()
    .then((resp) => {
      if (resp.rtncode === 1) {
        if (resp.rltcode === 1) {
          console.log('==========templogin=============')
          if (
            //resp.accounttype === 0&&
            sessionStorage.getItem("userId") === null &&
            VueCookie.get("cookieObj") === null
          ) {
            store.commit("user/setUserId", resp.userid);
            store.commit("user/setUserGuid", resp.userguid);
            store.commit("user/setRealName", resp.realname);
            store.commit("user/setToken", resp.token);
            store.commit("user/setMobileNum", resp.mobilenum);
            store.commit("user/setAccountType", resp.accounttype);
            store.commit("user/setPermission", resp.permission);
            store.commit("user/setAccountStatus", resp.accountstatus);
            store.commit("user/setShowMsg", resp.showmsg);
            store.commit("user/setMaxOpenNum", resp.maxopendocnum)
            store.commit("user/setOpenNum", resp.opendocnum)
            store.commit("user/setMallVer", resp.mallver)
            store.commit("user/setMaxToken", resp.maxtokens)

            localStorage.setItem("userguid", resp.userguid);
            sessionStorage.setItem("token", resp.token);
            if (resp.permission != null && resp.permission.length > 0) {
              let items = [];
              resp.permission.forEach((item) => {
                items.push(item.f);
              });
              store.commit("user/setPermissionArray", items);
            }
            let str = resp.userguid.slice(0, 3)
            if (resp.accounttype == 3 && str != 'TMP') {
              setTimeout(() => {
                router.push("/newFiles")
              }, 5000)
              return false
            }
          }

          ok();
        }
      }
    })
    .catch((err) => {
      console.log("临时登录err", err);
    });
};

export const GETANYTHING = function () {
  reqGetIndustry(); // 行业
  reqGetTaxes(); // 税种
  reqGetInOut(); // 进出口
  reqGetReduction(); // 优惠项目
  reqGetReduction_tax(); // 优惠税种
  reqGetReduction_industry(); // 优惠行业
  reqGetCountry(); // 获取国家
};

// 获取定位
export const getTempLocation = function (ok, x, y) {
  $http
    .ReqGetLocation(x, y)
    .then((res) => {
      if (res.rtncode === 1) {
        if (res.rltcode === 1) {
          console.log("定位999", res);
          // 定位成功 
          window.localStorage.setItem("valueProvCode", res.postion.provice);
          window.localStorage.setItem("valueP", res.postion.provicelabel);
          window.localStorage.setItem("valueCityCode", res.postion.city);
          window.localStorage.setItem("valueC", res.postion.citylabel);
        } else if (res.rltcode === -1) {
          window.localStorage.setItem("valueProvCode", res.postion.provice);
          window.localStorage.setItem("valueP", res.postion.provicelabel);
          window.localStorage.setItem("valueCityCode", res.postion.city);
          window.localStorage.setItem("valueC", res.postion.citylabel);
        } else {
          window.localStorage.setItem("valueProvCode", "");
          window.localStorage.setItem("valueP", "");
          window.localStorage.setItem("valueCityCode", "");
          window.localStorage.setItem("valueC", "");
        }
      } else {
        window.localStorage.setItem("valueProvCode", "");
        window.localStorage.setItem("valueP", "");
        window.localStorage.setItem("valueCityCode", "");
        window.localStorage.setItem("valueC", "");
      }
    })
    .catch(() => {
      window.localStorage.setItem("valueProvCode", "");
      window.localStorage.setItem("valueP", "");
      window.localStorage.setItem("valueCityCode", "");
      window.localStorage.setItem("valueC", "");
    })
    .finally(() => {
      ok();
    });
};
// 行业
function reqGetIndustry() {
  $http.reqGetIndustry().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetIndustry", res.datas);
        localStorage.setItem("reqGetIndustry", JSON.stringify(res.datas));
      }
    }
  });
}
// 税种
function reqGetTaxes() {
  $http.reqGetTaxes().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetTaxes", res.datas);
        localStorage.setItem("reqGetTaxes", JSON.stringify(res.datas));
      }
    }
  });
}
// 进出口
function reqGetInOut() {
  $http.reqGetInOut().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetInOut", res.datas);
        localStorage.setItem("reqGetInOut", JSON.stringify(res.datas));
      }
    }
  });
}
// 优惠项目
function reqGetReduction() {
  $http.reqGetReduction().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetReduction", res.datas);
        localStorage.setItem("reqGetReduction", JSON.stringify(res.datas));
      }
    }
  });
}
// 优惠税种
function reqGetReduction_tax() {
  $http.reqGetReduction_tax().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetReduction_tax", res.datas);
        localStorage.setItem("reqGetReduction_tax", JSON.stringify(res.datas));
      }
    }
  });
}
// 优惠行业
function reqGetReduction_industry() {
  $http.reqGetReduction_industry().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch(
          "commonSearchData/updatereqGetReduction_industry",
          res.datas
        );
        localStorage.setItem(
          "reqGetReduction_industry",
          JSON.stringify(res.datas)
        );
      }
    }
  });
}
// 获取国家
function reqGetCountry() {
  $http.reqGetCountry().then((res) => {
    if (res.rtncode === 1) {
      if (res.rltcode === 1) {
        store.dispatch("commonSearchData/updatereqGetCountry", res.datas);
        localStorage.setItem("reqGetCountry", JSON.stringify(res.datas));
      }
    }
  });
}
